declare const window: {
	sa_event: any;
};

const isBrowser = typeof document !== "undefined";

export function trackEvent(name: string, metadata?: any) {
	if (!isBrowser || !window.sa_event) {
		return;
	}
	try {
		window.sa_event(name, metadata);
	} catch (e) {
		// ignore errors
	}
}

export function createTransactionSizeBucket(size: number): number {
	if (size <= 1) {
		return 0;
	}
	if (size <= 100) {
		return 100;
	}
	if (size <= 500) {
		return 500;
	}
	if (size <= 1000) {
		return 1000;
	}

	return Math.ceil(size / 1000) * 1000;
}
